// @flow
import { CancelToken } from 'axios';
import request from './request';

import type { Request, Response, Cancel } from '../types';

type Return = {
  response: Promise<Response>,
  cancel: Cancel,
};

const cancelable = (req: Request): Return => {
  // Create cancel
  let cancel = () => undefined;
  const cancelToken = new CancelToken(c => {
    cancel = c;
  });

  const response = request({
    ...req,
    cancelToken,
  });

  return {
    response,
    cancel,
  };
};

export default cancelable;
